import axios from '@/api/axiosInstance';

export default async function getFeatureFlags() {
  const apiUrl = process.env.API || process.env.NEXT_PUBLIC_API;
  const response = await axios.get(`${apiUrl}/feature-flags`);
  return response.data;
}
